<template>
  <div
    :ref="generateSafeId(fieldQuestionId, 'wrapper')"
    class="RMPE-DynamicField"
    :class="{ 'RMPE-HasError': fieldHasError }"
  >
    <component
      :is="layout.type"
      :image="layout.image"
      :video="layout.video"
    >
      <div class="field">
        <div class="control">
          <label
            ref="auto-focus-target"
            class="label RMPE-DynamicField-Label"
            tabindex="0"
          >
            <span
              :class="{'RMPE-Required': question.required}"
              v-html="question.formattedLabel"
            />
          </label>

          <HintMessage :hint="question.formattedDescription" />

          <ul class="RMPE-DynamicCheckboxes">
            <li
              v-for="(option, index) in options"
              :key="option.id"
            >
              <label
                :id="generateSafeId(fieldQuestionId, option.id, 'label')"
                :ref="index === 0 ? 'auto-focus-target' : null"
                class="RMPE-DynamicCheckbox"
                :for="generateSafeId(fieldQuestionId, option.id)"
                :class="{'isSelected': isSelected(option.id)}"
                tabindex="0"
                @keydown.space.prevent="emitChange(option.id)"
              >
                <input
                  :id="generateSafeId(fieldQuestionId, option.id)"
                  :value="option.id"
                  :checked="fieldValue === option.id"
                  :name="question.id"
                  type="radio"
                  autocomplete="no"
                  @change="emitChange(option.id)"
                >

                <span class="RMPE-DynamicCheckbox-Label">
                  <kbd class="RMPE-KeyboardKey">
                    {{ option.keyboardShortcut }}
                  </kbd>
                  <span>
                    {{ option.label }}
                  </span>
                </span>
              </label>
            </li>
          </ul>

          <ErrorMessage
            :field-has-error="fieldHasError"
            :errors="error.errors"
            :is-blurred="isBlurred"
          />

          <MediaMiddlePartial :layout="layout" />
        </div>
        <div class="RMPE-DynamicForm-SubmitContainer">
          <button
            :disabled="isNextButtonDisabled"
            class="button is-primary RMPE-CustomSubmit"
            @click="goToNextQuestion"
          >
            {{ question.goToNextQuestionButtonLabel }}
          </button>
        </div>
      </div>
    </component>
  </div>
</template>

<script>
import DynamicFieldMixin from '../../mixins/dynamic-field-mixin';
import CheckboxFieldMixin from '../common/checkbox-field';

export default {
  mixins: [DynamicFieldMixin, CheckboxFieldMixin],

  computed: {
    options() {
      return [
        {
          id: true,
          label: 'Yes',
          keyboardShortcut: 'Y',
        },
        {
          id: false,
          label: 'No',
          keyboardShortcut: 'N',
        },
      ];
    },
  },

  methods: {
    isSelected(id) {
      return this.fieldValue === id;
    },
    emitChange(option) {
      this.$emit('change', option);
    },
    handleKeydownEvent(event) {
      if (event.code === 'KeyY') {
        this.$emit('change', true);
        document.querySelector(`#${this.generateSafeId(this.fieldQuestionId, true, 'label')}`).focus();
      } else if (event.code === 'KeyN') {
        this.$emit('change', false);
        document.querySelector(`#${this.generateSafeId(this.fieldQuestionId, false, 'label')}`).focus();
      }
    },
  },
};
</script>

<style scoped lang="scss">

</style>
